<script setup lang="ts">
import { ref, toRefs, computed, watch } from 'vue';
import { debounce } from '@/utils/index';
const emit = defineEmits(['input', 'blur', 'change', 'update:modelValue']);

const props = defineProps({
  modelValue: [String, Number],
  title: { type: String, default: '' },
  placeholder: { type: String, default: '请输入内容' },
  width: { type: Number, default: 180 },
  height: { type: Number, default: 28 },
  fontSize: { type: Number, default: 12 },
  maxlength: { type: Number, default: 99999 },
  disabled: { type: Boolean, default: false },
  type: { type: String, default: 'text' },
  unit: { type: String, default: '' },
  pre: { type: String, default: '' },
  margin: { type: Boolean, default: false },
  inputWidth: { type: Number, default: 0 }, // 输入框宽度
  isAlignCenter: { type: Boolean, default: false }, //文字是否在输入框居中
});

const {
  placeholder,
  width,
  height,
  fontSize,
  maxlength,
  disabled,
  type,
  inputWidth,
  isAlignCenter,
} = toRefs(props);

const searchValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});

const isFocused = ref(false);

const hasAffix = computed(() => !!(props.pre || props.unit));

/** 有前缀/后缀时输入区用 flex 占满剩余宽度，避免单位（如 CNY）与数字重叠 */
const inputStyle = computed(() => {
  const base: Record<string, string> = {
    '--placeholder-font-size': `${props.fontSize}px`,
  };
  if (hasAffix.value) {
    return {
      ...base,
      flex: '1 1 0',
      minWidth: '0',
      width: 'auto',
    };
  }
  const w = props.inputWidth ? props.inputWidth : Number(props.width) - 28;
  return {
    ...base,
    width: `${w}px`,
  };
});

const handleFocus = () => {
  // isFocused.value = true
};
const handleBlur = () => {
  // isFocused.value = false
  emit('blur', searchValue.value);
};
const handleChange = () => {
  emit('change', searchValue.value);
};

//搜索框输入
const hangdleInput = debounce((e: any) => {
  searchValue.value = e.target.value;
  emit('input', e.target.value);
}, 500);
</script>

<template>
  <div class="fr-ac" :class="{ 'mt-16': margin }">
    <div class="fs-14 mr-2" v-if="title">{{ title }}</div>
    <div
      class="fr-ac search-box"
      :style="{ width: width + 'px', height: height + 'px' }"
      :class="{
        focused: isFocused,
        opa4: disabled,
        'search-box--affix': hasAffix,
      }"
    >
      <div v-if="pre" class="fs-14 opa4 mr-10 custom-input__affix">
        {{ pre }}
      </div>
      <input
        class="custom-input"
        :class="isAlignCenter ? 'align-center' : ''"
        :style="inputStyle"
        v-model="searchValue"
        :type="type"
        :placeholder="placeholder"
        :disabled="disabled"
        :maxlength="maxlength"
        @input="hangdleInput"
        @focus="handleFocus"
        @blur="handleBlur"
        @change="handleChange"
      />
      <div
        v-if="unit"
        class="fs-14 opa4 custom-input__affix custom-input__unit"
      >
        {{ unit }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.search-box {
  height: 28px;
  border-radius: var(--border-radius);
  padding: 0 14px;
  background: var(--input-bg-color);
  min-width: 0;

  &.search-box--affix {
    overflow: hidden;
  }

  .custom-input__affix {
    flex-shrink: 0;
    line-height: 1.2;
    white-space: nowrap;
    align-self: center;
  }

  .custom-input__unit {
    margin-left: 6px;
  }

  .custom-input {
    /* 使用 CSS 变量 */
    font-size: var(--placeholder-font-size);
  }

  .custom-input::placeholder {
    color: var(--input-placeholder-color);
    font-size: var(--placeholder-font-size);
  }

  .align-center {
    text-align: center;
  }
}
</style>
